module.exports = __webpack_public_path__ + "img/welcome-es.a22362e5.png";